import React, { useState, useRef, useEffect, useMemo } from "react";
import {
    Button,
    Typography,
    Tooltip,
    message,

} from "antd";
import { Box,useMediaQuery,Snackbar, Alert } from "@mui/material";
import {
    LeftCircleFilled,
    RightCircleFilled,
    InfoCircleOutlined,
} from "@ant-design/icons";
import { useParams } from "react-router-dom";
import {
    initializeJotURL,
    getJotURLInstance,
} from "../../services/api/JotURLService";

import { UIRecommendationAPIService } from "../../services/api/UIRecommendationAPIService";
import logoIcon from "../../assests/Images/kangaroo.webp";
import FooterSummary from "../../components/common/FooterSummary";
import ProductCardSkeleton from "../../components/common/ProductCardSkeleton";
import { shoppingListTrackingService } from "../../services/api/shoppingListTrackingService";
import { ProductItemV2 } from "../../components/common/ProductItemV2";
import { storeMeta } from "../../shared/utils";
import amazon_fresh from "../../assests/Images/amazon_fresh.png";
import amazon_lucky from "../../assests/Images/amazon_lucky.png";
import amazon_whole_food from "../../assests/Images/amazon_whole_food.png";
import amazon_icon from "../../assests/Images/amazon.png";


const { Title, Text } = Typography;

// Skeleton Category Section Component
const CategorySectionSkeleton = () => {
    const scrollContainerRef = useRef(null);

    return (
        <div style={{ marginBottom: "10px" }}>
            {/* <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: "16px",
        }}
      >
        <Skeleton.Input
          active
          size="default"
          style={{ width: "200px", height: "32px" }}
        />
      </div> */}

            <div style={{ position: "relative" }}>
                <div
                    ref={scrollContainerRef}
                    style={{
                        display: "flex",
                        overflowX: "auto",
                        scrollBehavior: "smooth",
                        paddingBottom: "8px",
                        scrollbarWidth: "none",
                        msOverflowStyle: "none",
                        WebkitOverflowScrolling: "touch",
                    }}
                    className="hide-scrollbar"
                >
                    {[0, 1, 2]?.map((index) => (
                        <ProductCardSkeleton key={index} index={index} />
                    ))}
                </div>
            </div>
        </div>
    );
};

const CategorySection = ({
    category,
    index,
    selectedProducts,
    onToggleProduct,
    maxSelectionReached,
    addToCard,
    selectedStore,
}) => {
    const scrollContainerRef = useRef(null);
    const [showLeftButton, setShowLeftButton] = useState(false);
    const [showRightButton, setShowRightButton] = useState(true);
    const [dataToShow, setDataToShow] = useState(category.products);
    const [isZerothIndexSame, setIsZerothIndexSame] = useState(false)
    const titleRef = useRef(null);
    const [isTruncated, setIsTruncated] = useState(false);
    const [tooltipOpen, setTooltipOpen] = useState(false);
    const tooltipContainerRef = useRef(null);
const [chipData, setChipData] = useState({});

    useEffect(() => {
        if (!tooltipOpen) return;

        const closeTooltip = () => {
            setTooltipOpen(false);
        };

        const handleClickOutside = (event) => {
            if (
                tooltipContainerRef.current?.contains(event.target) ||
                titleRef.current?.contains(event.target)
            ) {
                return;
            }
            closeTooltip();
        };

        // Listen to ALL scroll events (window + capture phase)
        const handleScroll = (e) => {
            closeTooltip();
        };

        // Click/Touch outside
        document.addEventListener('mousedown', handleClickOutside);
        document.addEventListener('touchstart', handleClickOutside, { passive: true });

        // Window scroll (page scroll)
        window.addEventListener('scroll', handleScroll, true);

        // Document scroll (captures all scrollable elements)
        document.addEventListener('scroll', handleScroll, true);

        // Mouse wheel
        document.addEventListener('wheel', handleScroll, { passive: true });

        // Touch gestures
        document.addEventListener('touchmove', handleScroll, { passive: true });

        // Window resize
        window.addEventListener('resize', handleScroll);

        // Keyboard
        const handleKeyDown = (e) => {
            if (e.key === 'Escape') closeTooltip();
        };
        document.addEventListener('keydown', handleKeyDown);

        // IMPORTANT: Horizontal scroll container
        const container = scrollContainerRef.current;
        if (container) {
            container.addEventListener('scroll', handleScroll, { passive: true });
        }

        // ALSO listen to parent scrollable containers
        let parent = tooltipContainerRef.current?.parentElement;
        const scrollableParents = [];

        while (parent) {
            const overflow = window.getComputedStyle(parent).overflow;
            const overflowY = window.getComputedStyle(parent).overflowY;
            const overflowX = window.getComputedStyle(parent).overflowX;

            if (
                overflow === 'auto' ||
                overflow === 'scroll' ||
                overflowY === 'auto' ||
                overflowY === 'scroll' ||
                overflowX === 'auto' ||
                overflowX === 'scroll'
            ) {
                scrollableParents.push(parent);
                parent.addEventListener('scroll', handleScroll, { passive: true });
            }
            parent = parent.parentElement;
        }

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
            document.removeEventListener('touchstart', handleClickOutside);
            window.removeEventListener('scroll', handleScroll, true);
            document.removeEventListener('scroll', handleScroll, true);
            document.removeEventListener('wheel', handleScroll);
            document.removeEventListener('touchmove', handleScroll);
            window.removeEventListener('resize', handleScroll);
            document.removeEventListener('keydown', handleKeyDown);

            if (container) {
                container.removeEventListener('scroll', handleScroll);
            }

            // Clean up parent listeners
            scrollableParents.forEach(parent => {
                parent.removeEventListener('scroll', handleScroll);
            });
        };
    }, [tooltipOpen]);

    useEffect(() => {
        const el = titleRef.current;
        if (el) {
            setIsTruncated(el.scrollWidth > el.clientWidth);
        }
    }, [category.name]);

    useEffect(() => {
        const container = scrollContainerRef.current;
        if (container) {
            container.scrollTo({
                left: 0,
                behavior: "smooth",
            });

            // reset arrow visibility
            setShowLeftButton(false);
            setShowRightButton(container.scrollWidth > container.clientWidth);
        }
    }, [selectedStore]);

    const scroll = (direction) => {
        const container = scrollContainerRef.current;
        if (container) {
            const scrollAmount = direction === "left" ? -200 : 200;
            container.scrollBy({ left: scrollAmount, behavior: "smooth" });
        }
    };

    const handleScroll = () => {
        const container = scrollContainerRef.current;
        if (container) {
            setShowLeftButton(container.scrollLeft > 0);
            setShowRightButton(
                container.scrollLeft <
                container.scrollWidth - container.clientWidth - 10
            );
        }
    };

    useEffect(() => {
        const container = scrollContainerRef.current;
        if (container) {
            handleScroll();
            container.addEventListener("scroll", handleScroll);
            return () => container.removeEventListener("scroll", handleScroll);
        }
    }, []);

    const storeAwareData = useMemo(() => {
    const cheapestItem = category?.cheapest_products_list?.find(
        (p) => p.store.toLowerCase() === selectedStore.toLowerCase()
    ) || null;

    const bestItem = category?.products?.find(
        (p) => p.store.toLowerCase() === selectedStore.toLowerCase()
    ) || null;

    const storeProducts = category?.products?.filter(
        (p) => p.store.toLowerCase() === selectedStore.toLowerCase()
    ) || [];

    const highestRatedItem = [...storeProducts].sort((a, b) => {
        const ratingDiff = (parseFloat(b.rating) || 0) - (parseFloat(a.rating) || 0);
        if (ratingDiff !== 0) return ratingDiff;
        return (parseInt(b.reviews) || 0) - (parseInt(a.reviews) || 0);
    })[0] || null;

    // Create chip map
    const chipMap = {};
    const addChip = (productKey, chipType) => {
        if (!productKey) return;
        if (!chipMap[productKey]) chipMap[productKey] = [];
        if (!chipMap[productKey].includes(chipType)) {
            chipMap[productKey].push(chipType);
        }
    };

    if (cheapestItem?.key) addChip(cheapestItem.key, 'cheapest');
    if (bestItem?.key) addChip(bestItem.key, 'best');
    if (highestRatedItem?.key) addChip(highestRatedItem.key, 'highest');

    // ✅ NEW: If all three chips are on the same product, keep only "best"
    Object.keys(chipMap).forEach(productKey => {
        const chips = chipMap[productKey];

        if (chips.includes('cheapest') &&
            chips.includes('highest') &&
            chips.includes('best')) {
            chipMap[productKey] = ['best'];
        }
    });

    return { cheapestItem, bestItem, highestRatedItem, chipMap };
}, [selectedStore, category]);

const filteredProducts = useMemo(() => {
        const source = category.products;
        return selectedStore = source.filter((product) => product.store.toLowerCase() === selectedStore.toLowerCase())

    }, [selectedStore]);

    useEffect(() => {
    const { cheapestItem, highestRatedItem, bestItem, chipMap } = storeAwareData;

    // Sort by score first, then by rating
    const sortedProducts = [...filteredProducts].sort((a, b) => {
        const scoreDiff = (b.score || 0) - (a.score || 0);
        if (scoreDiff !== 0) return scoreDiff;
        return (b.rating || 0) - (a.rating || 0);
    });

    // Build final list with priority items at top
    let finalList = [...sortedProducts];
    const priorityItems = [];
    const usedKeys = new Set();

    // ✅ Order: Cheapest → Highest Rated → Best Value
    const priorityOrder = [cheapestItem, highestRatedItem, bestItem];

    priorityOrder.forEach(item => {
        if (item && !usedKeys.has(item.key)) {
            priorityItems.push(item);
            usedKeys.add(item.key);
            finalList = finalList.filter((p) => p.key !== item.key);
        }
    });

    // Combine: priority items first, then sorted remaining
    setDataToShow([...priorityItems, ...finalList]);
    setChipData(chipMap); // ✅ NEW: Set chip data

}, [selectedStore, filteredProducts, storeAwareData]);


    return (
        <div>
            <div className="flex items-center mb-4">
                {/* LEFT — Title (50%) */}
                <div
                ref={tooltipContainerRef}
                    className="basis-[40%]
      max-w-[40%]
      md:basis-auto md:max-w-none md:flex-1 overflow-hidden"
                >
                    <Tooltip
                        title={`${category.name.charAt(0).toUpperCase() + category.name.slice(1)
                            }`}
                        placement="top"
                        open={isTruncated ? tooltipOpen : false}  // CONTROL OPEN STATE
                        onOpenChange={(visible) => {  // ADD THIS
                            if (isTruncated) {
                                setTooltipOpen(visible);
                            }
                        }}
                        trigger="click"
                        destroyTooltipOnHide={true}
                    >
                        <p
                            ref={titleRef}
                            onClick={() => {  // ADD CLICK HANDLER
                                if (isTruncated) {
                                    setTooltipOpen(!tooltipOpen);
                                }
                            }}
                            className="font-semibold text-gray-900 truncate cursor-default"
                        >
                            {index + 1}.{" "}
                            {category.name.charAt(0).toUpperCase() + category.name.slice(1)}
                        </p>
                    </Tooltip>
                </div>
            </div>

            <div style={{ position: "relative" }}>
                {(showLeftButton && dataToShow?.length > 0) && (
                    <Button
                        shape="circle"
                        icon={<LeftCircleFilled style={{ fontSize: "24px" }} />}
                        onClick={() => scroll("left")}
                        style={{
                            position: "absolute",
                            left: "-12px",
                            top: "50%",
                            transform: "translateY(-50%)",
                            zIndex: 10,
                            width: "48px",
                            height: "48px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            backgroundColor: "white",
                            border: "1px solid #d9d9d9",
                            boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
                        }}
                    />
                )}

                {(showRightButton && dataToShow?.length > 0 )&& (
                    <Button
                        shape="circle"
                        icon={<RightCircleFilled style={{ fontSize: "24px" }} />}
                        onClick={() => scroll("right")}
                        style={{
                            position: "absolute",
                            right: "-12px",
                            top: "50%",
                            transform: "translateY(-50%)",
                            zIndex: 10,
                            width: "48px",
                            height: "48px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            backgroundColor: "white",
                            border: "1px solid #d9d9d9",
                            boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
                        }}
                    />
                )}

                <div
                    ref={scrollContainerRef}
                    style={{
                        display: "flex",
                        overflowX: "auto",
                        scrollBehavior: "smooth",
                        paddingBottom: "8px",
                        scrollbarWidth: "none",
                        msOverflowStyle: "none",
                        WebkitOverflowScrolling: "touch",
                    }}
                    className="hide-scrollbar"
                >
                    {dataToShow?.length === 0 ? "No product found" :
                        dataToShow?.map((product, index) => {
                            const uniqueId = `${category.id}-${product.key || product.id}`;
const productChips = chipData[product.key] || []; // ✅ NEW
                            return (
                                <ProductItemV2
                                    key={uniqueId}
                                    product={product}
                                    isHighlighted={index === 0}
                                    isHighlightedFirst={index === 1}
                                    isZerothIndexSame={isZerothIndexSame}
                                    selectedStore={selectedStore}
                                    productChips={productChips}
                                    addToCard={(data) => {
                                        addToCard(data)
                                    }}
                                />
                            );
                        })}
                </div>
            </div>
        </div>
    );
};

export default function ShoppingListV2({
    loadingSkeleton: initialLoadingSkeleton = false,
    phone,
    productId,
    shopperooRender = false,
    onRenderComplete,
}) {
    const [selectedProducts, setSelectedProducts] = useState([]);
    const [isProcessing, setIsProcessing] = useState(false);
    const [jotURLInitialized, setJotURLInitialized] = useState(false);
    const [loadingSkeleton, setLoadingSkeleton] = useState(
        initialLoadingSkeleton
    );
    const [newProductList, setNewProductList] = useState([]);

    let { phoneNumber, id, adminView } = useParams();

    if (adminView) {
        shopperooRender = true;
    }

    const [data, setData] = useState(null);
    const [productData, setProductData] = useState(null);
    const [storeDetails, setStoreDetails] = useState([]);
    const [loading, setLoading] = useState(false);
    const [selectedStore, setSelectedStore] = useState("Amazon");
    const [savingsPercent, setSavingsPercent] = useState(0)
    const [savingsAmount, setSavingsAmount] = useState(0)
    const [cartModal, setCartModal] = useState(null);

     const isDesktop = useMediaQuery("(min-width:768px)");
      const isMobile = useMediaQuery("(max-height:690px)");
      const mediumHeightDEvice = useMediaQuery("(max-height:760px)");

    const MAX_SELECTION = 30;
    const ASSOCIATE_TAG = "shopperoo0f-20";


    const [snackData, setSnackData] = useState({
        show: false,
        message: "",
        type: "error",
    });

    const hasCalledOnRenderRef = useRef(false);
    const trackingTimeoutRef = useRef({});

    useEffect(() => {
        if (
            phoneNumber &&
            id &&
            !loadingSkeleton &&
            productData &&
            productData?.length > 0
        ) {
            const categoriesData = productData?.map((category) => ({
                category_name: category.category_name || category.name,
                products:
                    category.products?.map((p) => ({
                        product_id: p.key,
                        product_title: p.title,
                        store: p.store,
                        price: p.price,
                        unit_price: p.unit_price,
                    })) || [],
            }));

            if (!adminView) {
                // Track with session tracking service
                shoppingListTrackingService.trackListView(
                    phoneNumber,
                    id,
                    categoriesData
                );

                console.log("Session ID:", shoppingListTrackingService.getSessionId());
                console.log("Visitor ID:", shoppingListTrackingService.getVisitorId());
            }
        }
    }, [phoneNumber, id, loadingSkeleton, productData]);

    useEffect(() => {
        // Only call onRenderComplete once when data is first loaded
        if (
            !loadingSkeleton &&
            onRenderComplete &&
            !hasCalledOnRenderRef.current &&
            productData
        ) {
            hasCalledOnRenderRef.current = true;
            // Small delay to ensure DOM is updated
            setTimeout(() => {
                onRenderComplete();
            }, 100);
        }
    }, [loadingSkeleton, productData]);

    useEffect(() => {
        // Only call onRenderComplete once when data is first loaded
        if (loadingSkeleton) {
            hasCalledOnRenderRef.current = true;
            // Small delay to ensure DOM is updated
            setTimeout(() => {
                onRenderComplete();
            }, 100);
        }
    }, [loadingSkeleton]);

    useEffect(() => {
        setLoadingSkeleton(initialLoadingSkeleton);
    }, [initialLoadingSkeleton]);

    if (!phoneNumber && !id && !loadingSkeleton) {
        phoneNumber = phone;
        id = productId;
    }

    useEffect(() => {
        if (!phoneNumber && !id) return;
        setLoading(true);
        UIRecommendationAPIService.shoppingList(phoneNumber, id)
            .then((response) => {
                setData(response || {});
                setProductData(response?.searched_products || []);
                setStoreDetails(response?.store_details);
                const store = response?.store_details?.find((store) => store.store.toLowerCase() === "amazon") || {}
                setSavingsPercent(store?.savings_percent || 0)
                setSavingsAmount(store?.savings_amount || 0)
                // Hide skeleton when data is loaded
                setLoadingSkeleton(false);
            })
            .catch((err) => {
                console.error("Error fetching product data:", err);
                setLoadingSkeleton(false);
            })
            .finally(() => setLoading(false));
    }, [phoneNumber, id]);

    useEffect(()=>{
        if(storeDetails?.length ===1)
        {
            setSelectedStore(storeDetails[0]['store'])
        }

    },[storeDetails])

    const previousQuantitiesRef = useRef({});

    // Track quantity selection
    const handleQuantityTracking = (
        productKey,
        quantity,
        price,
        categoryData,
        upc,
        walmart_item_id,
        vendor
    ) => {
        if (!phoneNumber || !id || !categoryData || adminView) return;

        const previousQuantity = previousQuantitiesRef.current[productKey] || 0;
        if (previousQuantity === quantity) {
            return;
        }

        previousQuantitiesRef.current[productKey] = quantity;

        if (trackingTimeoutRef.current[productKey]) {
            clearTimeout(trackingTimeoutRef.current[productKey]);
        }

        trackingTimeoutRef.current[productKey] = setTimeout(() => {
            shoppingListTrackingService.trackQuantitySelection(phoneNumber, id, {
                category: categoryData.category_name,
                product_id: productKey,
                product_title: categoryData.product_title,
                quantity: quantity,
                store: categoryData.store,
                price: price,
                unit_price: categoryData.unit_price,
                upc: upc,
                walmart_item_id:walmart_item_id,
                vendor:vendor
            });
        }, 500);
    };
    // ADDED: Clean up timeouts on unmount
    useEffect(() => {
        return () => {
            // Clear all timeouts
            Object.values(trackingTimeoutRef.current).forEach((timeout) => {
                clearTimeout(timeout);
            });
            // Clear previous quantities
            previousQuantitiesRef.current = {};
        };
    }, []);

    useEffect(() => {
        try {
            initializeJotURL(
                "murtaza.salumber@meetpoppins.com",
                "57620ea2ea42a1a206857e062a786bfb",
                "cd09f1441b45e288ed91d84c5f6f6196"
            );
            setJotURLInitialized(true);
            console.log("✅ JotURL service initialized");
        } catch (error) {
            console.error("❌ Failed to initialize JotURL:", error);
        }
    }, []);

    const toggleProduct = (uniqueId, product) => {
        setSelectedProducts((prev) => {
            const exists = prev?.find((p) => p.uniqueId === uniqueId);

            if (exists) {
                return prev.filter((p) => p.uniqueId !== uniqueId);
            } else {
                if (prev?.length >= MAX_SELECTION) {
                    message.warning(`You can only select up to ${MAX_SELECTION} items`);
                    return prev;
                }
                return [
                    ...prev,
                    {
                        uniqueId,
                        product_key: product.key || product.id,
                        ...product,
                    },
                ];
            }
        });
    };

    const createGroceryDeepLink = async (products, vendorType) => {
        console.log("function me aaya")
    const { actionUrl, payload } = createAmazonGroceryForm(products, vendorType);

    try {
        // Call your Python API to create the redirect link
        const response = await fetch(`${process.env.REACT_APP_MESSAGE_HANDLER_URL}/api/grocery-cart/create`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                vendor: vendorType,
                actionUrl: actionUrl,
                payload: payload
            })
        });

        if (!response.ok) {
            const errorData = await response.json();
            throw new Error(errorData.error || `HTTP error! status: ${response.status}`);
        }

        const data = await response.json();
        const { redirectUrl } = data;

        console.log(`Created redirect URL for ${vendorType}:`, redirectUrl);

        // Shorten with JotURL
        const jotURLService = getJotURLInstance();
        const deepLink = await jotURLService.createShortLink(redirectUrl);

        console.log(`${vendorType} Deep Link (shortened):`, deepLink);

        return deepLink;
    } catch (error) {
        console.error(`Error creating ${vendorType} deep link:`, error);
        throw error;
    }
};
    const createAmazonCartLink = (products) => {
        if (!products || products?.length === 0) {
            return null;
        }

        if (phoneNumber && id && productData) {
            const selectedProductsForTracking = [];
            const categoriesIncluded = [];

            products.forEach((productInCart) => {
                productData.forEach((category) => {
                    const foundProduct = category.products?.find(
                        (p) => p.key === productInCart.productKey
                    );
                    if (foundProduct) {
                        selectedProductsForTracking.push({
                            product_id: foundProduct.key,
                            product_title: foundProduct.title,
                            quantity: productInCart.quantity,
                            price: productInCart.price,
                        });

                        const categoryName = category.category_name || category.name;
                        if (!categoriesIncluded.includes(categoryName)) {
                            categoriesIncluded.push(categoryName);
                        }
                    }
                });
            });

            const totalPrice = selectedProductsForTracking.reduce(
                (sum, p) => sum + p.price * p.quantity,
                0
            );

            // Use session tracking service instead
            if (!adminView) {
                shoppingListTrackingService.trackAmazonButtonClick(phoneNumber, id, {
                    total_items: selectedProductsForTracking?.length,
                    total_price: totalPrice,
                    categories_included: categoriesIncluded,
                    products: selectedProductsForTracking,
                },"Amazon");
            }
        }

        const baseUrl = "https://www.amazon.com/gp/aws/cart/add.html";
        const params = new URLSearchParams();
        params.append("AssociateTag", ASSOCIATE_TAG);

        products.forEach((product, index) => {
            const asinNumber = index + 1;
            params.append(`ASIN.${asinNumber}`, product?.productKey);
            params.append(`Quantity.${asinNumber}`, product?.quantity || 1);
        });

        return `${baseUrl}?${params.toString()}`;
    };
    const createWalmartCartLink = (products) => {
        const WALMART_PUBLISHER_ID = "3699778"; // Replace with your actual Impact Radius publisher ID
        const WALMART_AD_ID = "565706";

        const IMPACT_PUBLISHER_ID ="6478611";
        const AD_ID="1398372";
        const WALMART_IMPACT_CAMPAIGN_ID="16662";
        const aff="aff";
        const SOURCE_ID="1";

        if (!products || products?.length === 0) {
            return null;
        }

        // Track similar to Amazon if needed
        if (phoneNumber && id && productData) {
            const selectedProductsForTracking = [];
            const categoriesIncluded = [];

            products.forEach((productInCart) => {
                productData.forEach((category) => {
                    const foundProduct = category.products?.find(
                        (p) => p.key === productInCart.productKey
                    );
                    if (foundProduct) {
                        selectedProductsForTracking.push({
                            product_id: foundProduct.key,
                            product_title: foundProduct.title,
                            quantity: productInCart.quantity,
                            price: productInCart.price,
                        });

                        const categoryName = category.category_name || category.name;
                        if (!categoriesIncluded.includes(categoryName)) {
                            categoriesIncluded.push(categoryName);
                        }
                    }
                });
            });

            const totalPrice = selectedProductsForTracking.reduce(
                (sum, p) => sum + p.price * p.quantity,
                0
            );

            // Track Walmart button click
            if (!adminView) {
                shoppingListTrackingService.trackAmazonButtonClick(phoneNumber, id, {
                    total_items: selectedProductsForTracking?.length,
                    total_price: totalPrice,
                    categories_included: categoriesIncluded,
                    products: selectedProductsForTracking,
                },"Walmart");
            }
        }

        // Build items parameter: itemId_quantity,itemId_quantity,...
        const itemsParam = products
            ?.map((product) => {
                const itemId = product.walmart_item_id;
                const quantity = product.quantity || 1;
                return `${itemId}_${quantity}`;
            })
            .join(',');

        // Build the Walmart cart URL
        // const walmartCartUrl = `https://www.walmart.com/cart?action=AddToCart&items=${itemsParam}`;
        // const walmartCartUrl = `https://www.walmart.com/sc/cart/addToCart?items=${itemsParam}`;
        const walmartCartUrl = `https://affil.walmart.com/cart/addToCart?items=${itemsParam}`;

        // URL encode the Walmart cart URL for Impact Radius
        const encodedWalmartUrl = encodeURIComponent(walmartCartUrl);

        // Build the Impact Radius affiliate link
        // const impactRadiusUrl = `https://goto.walmart.com/c/${WALMART_PUBLISHER_ID}/${WALMART_AD_ID}?u=${encodedWalmartUrl}`;
        const impactRadiusUrl = `https://goto.walmart.com/m/${IMPACT_PUBLISHER_ID}/${AD_ID}/${WALMART_IMPACT_CAMPAIGN_ID}?veh=${aff}&sourceid=${SOURCE_ID}&u=${encodedWalmartUrl}`;

        return impactRadiusUrl;
    };

    const openKrogerAuthWindow = ({ payload }) => {
        // Track Kroger button click BEFORE opening auth window
    if (phoneNumber && id && productData && !adminView) {
        const selectedProductsForTracking = [];
        const categoriesIncluded = [];

        // Extract tracking data from payload
        payload.items.forEach((productInCart) => {
            productData.forEach((category) => {
                const foundProduct = category.products?.find(
                    (p) => p.upc === productInCart.upc
                );
                if (foundProduct) {
                    selectedProductsForTracking.push({
                        product_id: foundProduct.key,
                        product_title: foundProduct.title,
                        quantity: productInCart.quantity,
                        price: foundProduct.price,
                    });

                    const categoryName = category.category_name || category.name;
                    if (!categoriesIncluded.includes(categoryName)) {
                        categoriesIncluded.push(categoryName);
                    }
                }
            });
        });

        const totalPrice = selectedProductsForTracking.reduce(
            (sum, p) => sum + p.price * p.quantity,
            0
        );

        // Track Kroger button click
        shoppingListTrackingService.trackAmazonButtonClick(phoneNumber, id, {
            total_items: selectedProductsForTracking?.length,
            total_price: totalPrice,
            categories_included: categoriesIncluded,
            products: selectedProductsForTracking,
        }, "Kroger");
    }
        const krogerUrl =
            `${process.env.REACT_APP_KROGER_AUTH_API}&client_id=${process.env.REACT_APP_KROGER_CLIENT_ID}&redirect_uri=${process.env.REACT_APP_KROGER_CALLBACK_URL}?products=${JSON.stringify(payload)}`;
        window.open(
            krogerUrl,
            "kroger-auth",
        );
    };

    const handleLinkOpen = (deepLink) => {
        const win = window.open(deepLink, "_blank", "noopener,noreferrer");

        if (!win) {
            // Safari popup blocked → fallback
            window.location.href = deepLink;
        }
        setLoading(false);
        setIsProcessing(false);
    };

    const createVendorSpecificCarts = (products) => {
    // Separate products by vendor
    const vendorGroups = {
        amazon_fresh: [],
        whole_foods: [],
        lucky: [],
        amazon: [] // Regular Amazon (vendor is null or not specified)
    };

    products.forEach(product => {
        const vendor = product.vendor?.toLowerCase();

        if (vendor === 'amazon_fresh') {
            vendorGroups.amazon_fresh.push(product);
        } else if (vendor === 'whole_foods') {
            vendorGroups.whole_foods.push(product);
        } else if (vendor === 'lucky') {
            vendorGroups.lucky.push(product);
        } else {
            // No vendor or regular amazon
            vendorGroups.amazon.push(product);
        }
    });

    return vendorGroups;
};

const createAmazonGroceryForm = (products, vendorType) => {
    const AFFILIATE_TAG = "shopperoo-20";
    const BASE_URL = "https://www.amazon.com/afx/ingredients/landing";

    // Vendor-specific brand IDs
    const BRAND_IDS = {
        amazon_fresh: "QW1hem9uIEZyZXNo",
        whole_foods: "VUZHIFdob2xlIEZvb2Rz",
        lucky: "WQppp1xWMK"
    };

    // Build URL with vendor-specific brand ID
    let actionUrl = `${BASE_URL}?tag=${AFFILIATE_TAG}`;
    if (BRAND_IDS[vendorType]) {
        actionUrl += `&almBrandId=${BRAND_IDS[vendorType]}`;
    }

    // Build ingredients payload
    const ingredients = products?.map(product => {
        console.log("products whole food",product)
        const ingredient = {
            name: product.productTitle || product.title,
            quantityList: [{
                unit: "COUNT",
                amount: product.quantity || 1
            }]
        };

        // Add ASIN if available
        if (product.productKey) {
            ingredient.asinOverride = product.productKey;
        }

        return ingredient;
    });

    const payload = JSON.stringify({ ingredients });

    return { actionUrl, payload };
};

// Function to programmatically submit vendor form
const submitVendorForm = (actionUrl, payload, windowReference) => {
    return new Promise((resolve) => {
        const form = document.createElement('form');
        form.method = 'POST';
        form.action = actionUrl;
        form.target = windowReference.name; // Use the pre-opened window

        const input = document.createElement('input');
        input.type = 'hidden';
        input.name = 'ingredients';
        input.value = payload;

        form.appendChild(input);
        document.body.appendChild(form);

        // Submit to the already-open window
        form.submit();

        // Clean up
        setTimeout(() => {
            document.body.removeChild(form);
            resolve();
        }, 100);
    });
};

const delay = (ms) => new Promise(resolve => setTimeout(resolve, ms));

    const handleAddToCart = async () => {
    console.log("newProductList", newProductList?.length, selectedStore);

    if (newProductList?.length === 0) {
        message.warning("Please select at least one item");
        setSnackData({
            show: true,
            message: "Please select at least 1 item to add to your cart",
            type: "error",
        });
        return;
    }

    if (selectedStore.toLowerCase() === "kroger") {
        const krogerCart = newProductList?.map(({ upc, quantity }) => ({ upc, quantity }));
        const payload = {
            items: krogerCart
        };
        openKrogerAuthWindow({ payload });
    }
    else if (selectedStore.toLowerCase() === "walmart") {
        console.log("newProductList", newProductList);
        setLoading(true);
        setIsProcessing(true);

        try {
            const walmartCartUrl = createWalmartCartLink(newProductList);
            console.log("Walmart Cart URL:", walmartCartUrl);

            const jotURLService = getJotURLInstance();
            const deepLink = await jotURLService.createShortLink(walmartCartUrl);

            console.log("Walmart Deep Link:", deepLink);

            if (deepLink) {
                message.success("Redirecting to Walmart cart...");
                handleLinkOpen(deepLink);
            }
        } catch (error) {
            console.error("Error adding to Walmart cart:", error);
            message.error("Failed to add items to Walmart cart. Please try again.");
            setIsProcessing(false);
        }
    }
    else if (selectedStore.toLowerCase() === "amazon") {
        setLoading(true);
        setIsProcessing(true);

        try {
            // Separate products by vendor
            const vendorGroups = createVendorSpecificCarts(newProductList);

            // Track analytics
            if (phoneNumber && id && productData && !adminView) {
                const selectedProductsForTracking = [];
                const categoriesIncluded = [];

                newProductList.forEach((productInCart) => {
                    productData.forEach((category) => {
                        const foundProduct = category.products?.find(
                            (p) => p.key === productInCart.productKey
                        );
                        if (foundProduct) {
                            selectedProductsForTracking.push({
                                product_id: foundProduct.key,
                                product_title: foundProduct.title,
                                quantity: productInCart.quantity,
                                price: productInCart.price,
                            });

                            const categoryName = category.category_name || category.name;
                            if (!categoriesIncluded.includes(categoryName)) {
                                categoriesIncluded.push(categoryName);
                            }
                        }
                    });
                });

                const totalPrice = selectedProductsForTracking.reduce(
                    (sum, p) => sum + p.price * p.quantity,
                    0
                );

                shoppingListTrackingService.trackAmazonButtonClick(phoneNumber, id, {
                    total_items: selectedProductsForTracking?.length,
                    total_price: totalPrice,
                    categories_included: categoriesIncluded,
                    products: selectedProductsForTracking,
                }, "Amazon");
            }

            // ✅ NEW: Check how many vendor groups have products
            const vendorCount = [
                vendorGroups.amazon?.length > 0,
                vendorGroups.amazon_fresh?.length > 0,
                vendorGroups.whole_foods?.length > 0,
                vendorGroups.lucky?.length > 0
            ].filter(Boolean)?.length;

            console.log('📊 Vendor count:', vendorCount);

            // ✅ If ONLY ONE vendor, open directly without modal
            if (vendorCount === 1) {
                console.log('✅ Only one vendor detected, opening cart directly...');

                const jotURLService = getJotURLInstance();
                let deepLink;
                let vendorName;

                // Determine which vendor and create appropriate link
                if (vendorGroups?.amazon?.length > 0) {
                    const amazonCartUrl = createAmazonCartLink(vendorGroups.amazon);
                    deepLink = await jotURLService.createShortLink(amazonCartUrl);
                    vendorName = 'Amazon';
                }
                else if (vendorGroups?.amazon_fresh?.length > 0) {
                    deepLink = await createGroceryDeepLink(vendorGroups.amazon_fresh, 'amazon_fresh');
                    vendorName = 'Amazon Fresh';
                }
                else if (vendorGroups?.whole_foods?.length > 0) {
                    deepLink = await createGroceryDeepLink(vendorGroups.whole_foods, 'whole_foods');
                    vendorName = 'Whole Foods';
                }
                else if (vendorGroups?.lucky?.length > 0) {
                    deepLink = await createGroceryDeepLink(vendorGroups.lucky, 'lucky');
                    vendorName = 'Lucky';
                }

                console.log(`${vendorName} Deep Link:`, deepLink);

                if (deepLink) {
                    message.success(`Redirecting to ${vendorName} cart...`);
                    handleLinkOpen(deepLink);
                }

                setLoading(false);
                setIsProcessing(false);
                return; // Exit early, don't show modal
            }

            // ✅ Multiple vendors detected, show modal
            console.log('Multiple vendors detected, showing modal...');

            // Create deep links for all vendors in parallel
            const deepLinkPromises = [];
            const jotURLService = getJotURLInstance();

            // 1. Regular Amazon
            if (vendorGroups?.amazon?.length > 0) {
                deepLinkPromises.push(
                    (async () => {
                        const amazonCartUrl = createAmazonCartLink(vendorGroups.amazon);
                        const deepLink = await jotURLService.createShortLink(amazonCartUrl);

                        const totalPrice = vendorGroups.amazon.reduce(
                            (sum, p) => sum + (p.price * p.quantity),
                            0
                        );
                        const totalItems = vendorGroups.amazon.reduce(
                            (sum, p) => sum + p.quantity,
                            0
                        );

                        return {
                            type: 'amazon',
                            name: 'Amazon.com',
                            icon: amazon_icon,
                            deepLink,
                            totalPrice,
                            totalItems
                        };
                    })()
                );
            }

            // 2. Amazon Fresh
            if (vendorGroups?.amazon_fresh?.length > 0) {
                deepLinkPromises.push(
                    (async () => {
                        const deepLink = await createGroceryDeepLink(
                            vendorGroups.amazon_fresh,
                            'amazon_fresh'
                        );

                        const totalPrice = vendorGroups.amazon_fresh.reduce(
                            (sum, p) => sum + (p.price * p.quantity),
                            0
                        );
                        const totalItems = vendorGroups.amazon_fresh.reduce(
                            (sum, p) => sum + p.quantity,
                            0
                        );

                        return {
                            type: 'amazon_fresh',
                            name: 'Amazon Fresh',
                            icon: amazon_fresh,
                            deepLink,
                            totalPrice,
                            totalItems
                        };
                    })()
                );
            }

            // 3. Whole Foods
            if (vendorGroups?.whole_foods?.length > 0) {
                deepLinkPromises.push(
                    (async () => {
                        console.log("whole food me aaya ")
                        const deepLink = await createGroceryDeepLink(
                            vendorGroups.whole_foods,
                            'whole_foods'
                        );

                        const totalPrice = vendorGroups.whole_foods.reduce(
                            (sum, p) => sum + (p.price * p.quantity),
                            0
                        );
                        const totalItems = vendorGroups.whole_foods.reduce(
                            (sum, p) => sum + p.quantity,
                            0
                        );

                        return {
                            type: 'whole_foods',
                            name: 'Whole Foods',
                            icon: amazon_whole_food,
                            deepLink,
                            totalPrice,
                            totalItems
                        };
                    })()
                );
            }

            // 4. Lucky
            if (vendorGroups?.lucky?.length > 0) {
                deepLinkPromises.push(
                    (async () => {
                        const deepLink = await createGroceryDeepLink(
                            vendorGroups.lucky,
                            'lucky'
                        );

                        const totalPrice = vendorGroups.lucky.reduce(
                            (sum, p) => sum + (p.price * p.quantity),
                            0
                        );
                        const totalItems = vendorGroups.lucky.reduce(
                            (sum, p) => sum + p.quantity,
                            0
                        );

                        return {
                            type: 'lucky',
                            name: 'Lucky',
                            icon: amazon_lucky,
                            deepLink,
                            totalPrice,
                            totalItems
                        };
                    })()
                );
            }

            // Wait for all deep links to be created
            const carts = await Promise.all(deepLinkPromises);

            console.log('Created cart links:', carts);

            const sortedCarts = carts.sort((a, b) => b.totalPrice - a.totalPrice);

            // Calculate totals
            const grandTotal = carts.reduce((sum, cart) => sum + cart.totalPrice, 0);

            // Show modal with all carts
            setCartModal({
                carts: sortedCarts,
                grandTotal,
                savings: savingsAmount || 0
            });

            setLoading(false);
            setIsProcessing(false);

        } catch (error) {
            console.error("Error adding to cart:", error);
            message.error("Failed to add items to cart. Please try again.");
            setIsProcessing(false);
            setLoading(false);
        }
    }
};

    useEffect(() => {
        if (productData && productData?.length > 0) {
            const defaultSelections = productData
                .filter((category) => category?.products && category.products?.length > 0)
                ?.map((category) => {
                    const firstProduct = category.products[0];
                    const uniqueId = `${category.id}-${firstProduct.key || firstProduct.id
                        }`;

                    return {
                        uniqueId,
                        product_key: firstProduct.key || firstProduct.id,
                        ...firstProduct,
                    };
                });

            if (selectedProducts?.length === 0 && defaultSelections?.length > 0) {
                setSelectedProducts(defaultSelections);
            }
        }
    }, [productData]);



    const handleBackToMessages = () => {
        phoneNumber = process.env.REACT_APP_ROO_PHONE;
        if (phoneNumber) {
            window.location.href = `sms:${phoneNumber}`;
        } else {
            window.location.href = "sms:";
        }
    };

    // Cart Modal Component
const CartModal = () => {
    if (!cartModal) return null;

    const { carts, grandTotal, savings } = cartModal;

    const handleCartClick = (deepLink, vendorName) => {
        window.open(deepLink, '_blank', 'noopener,noreferrer');
        message.success(`Opening ${vendorName} cart in new tab...`);
    };

    // Button style based on screen size
    const buttonStyle = {
        fontSize: isMobile ? '10px' : '12px',
        padding: isMobile ? '10px': "10px",
        minWidth: isMobile ? '160px':"200px",
    };

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[300] p-4">
            <div className="bg-white rounded-2xl max-w-md w-full shadow-2xl max-h-[90vh] overflow-y-auto">
                {/* Header */}
                <div className="py-6 px-4 border-b border-gray-200 bg-white sticky top-0 z-10">
                    <div className="flex items-start justify-between mb-1">
                        <div className="flex-1">
                            <h3 className="text-[1.2rem] font-bold text-gray-900 mb-2">
                                Amazon won't let me make one cart 😅
                            </h3>
                            <p className="text-sm text-gray-600 mb-2">
                                I made {carts?.length} carts — tap each to add.
                            </p>
                            <p className="text-sm font-medium text-[#ff2999]">
                                ⚠️ Come back to this tab for the next cart!
                            </p>
                        </div>
                        <button
                            onClick={() => setCartModal(null)}
                            className="text-gray-400 hover:text-gray-600 text-2xl leading-none ml-2 flex-shrink-0"
                        >
                            ✕
                        </button>
                    </div>
                </div>

                {/* Cart List */}
                <div className="py-5 px-2.5 space-y-3">
                    {carts?.map((cart, index) => (
                        <div
                            key={index}
                            className="flex items-center justify-between gap-3 py-4 px-2 bg-gray-50 rounded-lg border border-gray-200"
                        >
                            {/* Left side - Logo and details */}
                            <div className="flex items-center gap-3 flex-1 min-w-0">
                                <div className="flex items-center justify-center w-12 h-12 bg-white rounded-lg border border-gray-200 p-2 flex-shrink-0">
                                    <img
                                        src={cart.icon}
                                        alt={cart.name}
                                        className="w-full h-full object-contain"
                                    />
                                </div>
                                <div className={`flex ${isMobile ? "flex-col" : "flex-row"} min-w-0`}>
                                    <p className="font-bold text-gray-900 truncate">
                                        ${cart.totalPrice.toFixed(2)}
                                    </p>
                                    <p className={`text-sm text-gray-600 truncate ${!isMobile ? "ml-[10px] mt-[3px]":""}`}>
                                        {cart.totalItems} item{cart.totalItems > 1 ? 's' : ''}
                                    </p>
                                </div>
                            </div>

                            {/* Right side - Add button (always floats right) */}
                            <button
                                onClick={() => handleCartClick(cart.deepLink, cart.name)}
                                style={buttonStyle}
                                className="bg-black hover:bg-gray-800 text-white rounded-lg font-semibold transition-all duration-200 active:scale-95 flex items-center justify-between whitespace-nowrap flex-shrink-0 ml-auto"
   >
                                <span>Add to {cart.name} Cart</span>
                                <span>→</span>
                            </button>
                        </div>
                    ))}
                </div>

                {/* Footer */}
                <div className="py-4 px-4 border-t border-gray-200 bg-gray-50 sticky bottom-0">
                    <div className="space-y-3">
                        <div className="flex items-center justify-between">
                            <span className="text-sm font-medium text-gray-700">
                                Total 🛒  <span className="text-sm font-bold text-gray-900">
                                ${grandTotal.toFixed(2)}
                            </span> · {carts.reduce((sum, cart) => sum + cart.totalItems, 0)} items
                            </span>

                        </div>

                        {savings > 0 && (
                            <div className="flex items-center justify-between border-gray-200">
                                <span className="text-sm font-medium text-gray-700">
                                    Saving ${savings.toFixed(2)} vs Amazon first picks
                                </span>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

    // Show loading screen only when fetching initial data (not skeleton)
    if (loading && !loadingSkeleton) {
        return (
            <Box
                sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    py: 8,
                    px: 2,
                }}
            >
                <Box
                    sx={{
                        fontSize: 60,
                        color: "#ff007f",
                        animation: "bounce 1s infinite",
                        "@keyframes bounce": {
                            "0%, 100%": { transform: "translateY(0)" },
                            "50%": { transform: "translateY(-10px)" },
                        },
                    }}
                >
                    <img
                        src={logoIcon}
                        style={{ width: "60px", height: "60px" }}
                        alt="Loading"
                    />
                </Box>

                <div
                    style={{
                        fontSize: "16px",
                        fontWeight: "400",
                        color: "#333",
                        textAlign: "center",
                        maxWidth: "400px",
                        fontFamily:
                            "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif",
                        WebkitFontSmoothing: "antialiased",
                        MozOsxFontSmoothing: "grayscale",
                    }}
                >
                    {isProcessing
                        ? "Building your cart now…"
                        : "Displaying your results…"}
                </div>
            </Box>
        );
    }

    const selectedCount = selectedProducts?.length;
    const maxSelectionReached = selectedCount >= MAX_SELECTION;

    const getUniqueProducts = (categories) => {
        const seenKeys = new Set();

        return categories?.map((category) => {
            const uniqueProducts =
                category.products?.filter((product) => {
                    const key = product.key;

                    if (seenKeys.has(key)) {
                        return false;
                    }

                    seenKeys.add(key);
                    return true;
                }) || [];

            return {
                ...category,
                products: uniqueProducts,
            };
        });
    };

    if (loadingSkeleton) {
        return <CategorySectionSkeleton />;
    }

    return (
        <div
            className="shopping_list_render"
            style={{
                backgroundColor: "white",
                padding: "16px",
                maxWidth: "1200px",
                margin: "0 auto",
            }}
        >
            <style>{`
        .hide-scrollbar::-webkit-scrollbar {
          display: none;
        }
      `}</style>

            <>
                <CartModal />
                {maxSelectionReached && (
                    <div
                        style={{
                            padding: "12px",
                            backgroundColor: "#fff7e6",
                            border: "1px solid #ffd591",
                            borderRadius: "8px",
                            marginBottom: "16px",
                        }}
                    >
                        <Text style={{ fontSize: "14px", color: "#d46b08" }}>
                            ⚠️ Maximum {MAX_SELECTION} items selected. Deselect an item to
                            choose a different one.
                        </Text>
                    </div>
                )}
            </>


            <div>
                <div className="flex flex-col gap-2 mb-6">
                    <div className="flex items-start gap-3 ">
                        <span className="text-xl">👉</span>
                        <p className="text-gray-800">
                            <span className="font-semibold text-sm">Pick your store ➜ Get items sorted by unit price ➜ 1-click add all to cart</span>
                        </p>
                    </div>

                </div>
                <div className="flex gap-2 flex-wrap mb-7">
    {storeDetails?.map((store) => {
        const isSelected = store.store === selectedStore;
        return (
            <button
                key={store.name}
                onClick={() => {
                    setSelectedStore(store.store)
                    setSavingsPercent(store.savings_percent)
                    setSavingsAmount(store.savings_amount)
                    setNewProductList([])
                }}
                className={`
                    w-[calc(50%-4px)]
                    sm:w-auto
                    sm:flex-1
                    md:w-[250px]
                    md:flex-none
                    flex gap-1 px-2 py-4 rounded-xl
                    ${isSelected
                        ? "border-2 border-[#0AE2CD] bg-teal-50"
                        : "border bg-gray-100"
                    }
                `}
            >
                <div className="flex flex-1 items-center ">
                    <div className="flex-1">
                        <div className="flex items-center gap-1 mb-4">
                            <div className="flex flex-1 items-center gap-1">
                                <img
                                    src={storeMeta[store.store]?.logo}
                                    alt={store}
                                    className="w-4 h-4 object-contain"
                                />
                                <p className="font-semibold text-sm">{store.store}</p>
                            </div>
                            {isSelected && (
                                <span className="text-[10px] font-semibold py-0.5 px-1 rounded-[5px] bg-teal-400 text-black">
                                    Selected
                                </span>
                            )}

                        </div>

                        <div className="flex items-center gap-2">
                            <span className="text-xs">🛒</span>
                            <p className="text-xl font-bold">${Number(store.total_cart_amount).toFixed(2)}</p>
                            <p className="text-[12px] text-black font-semibold mt-1">{store.total_items} items</p>
                        </div>
                    </div>
                </div>
            </button>
        );
    })}
</div>
                {(savingsAmount > 0 && savingsPercent >= 20) && <div className="inline-flex items-center gap-2 mb-6 px-3 py-2 rounded-[50px] bg-[#0AE2CD] text-black ">
                    <span className="text-[13px] font-semibold break-words">
                        💰 ${savingsAmount} saved vs {selectedStore} first picks
                    </span>
                </div>}
            </div>


            {getUniqueProducts(productData || [])?.map((category, index) => {
                return (
                    <div>
                        <CategorySection
                            key={category.id}
                            index={index}
                            category={category}
                            selectedProducts={selectedProducts}
                            onToggleProduct={toggleProduct}
                            selectedStore={selectedStore}
                            maxSelectionReached={maxSelectionReached}
                            addToCard={({
                                productKey,
                                quantity,
                                price,
                                shouldClear,
                                productTitle,
                                store,
                                unitPrice,
                                upc,
                                walmart_item_id,
                                vendor
                            }) => {
                                setNewProductList((prev) => {
                                    if (shouldClear) return [];
                                    const existingIndex = prev?.findIndex(
                                        (item) => item.productKey === productKey
                                    );

                                    // Track quantity change (including removal when quantity is 0)
                                    if (productKey && !shouldClear) {
                                        handleQuantityTracking(productKey, quantity, price, {
                                            category_name:
                                                category.category_name || category.name,
                                            product_title: productTitle,
                                            store: store,
                                            unit_price: unitPrice,
                                            upc: upc,
                                            walmart_item_id:walmart_item_id,
                                            vendor:vendor,
                                            productTitle:productTitle
                                        });
                                    }

                                    // Remove if quantity is 0
                                    if (quantity === 0) {
                                        if (existingIndex === -1) return prev;
                                        return prev.filter(
                                            (item) => item.productKey !== productKey
                                        );
                                    }

                                    // Update existing
                                    if (existingIndex !== -1) {
                                        const updated = [...prev];
                                        updated[existingIndex] = {
                                            ...updated[existingIndex],
                                            quantity: quantity,
                                            price: price,
                                            upc: upc,
                                            walmart_item_id:walmart_item_id,
                                            vendor:vendor,
                                            productTitle:productTitle

                                        };
                                        return updated;
                                    }

                                    return [
                                        ...prev,
                                        {
                                            productKey: productKey,
                                            quantity: quantity,
                                            price: price,
                                            upc: upc,
                                            walmart_item_id:walmart_item_id,
                                            vendor:vendor,
                                            productTitle:productTitle
                                        },
                                    ];
                                });
                            }}
                        />
                        {index === 0 ? (
                            <div className="inline-flex items-center gap-1 text-[10px] text-gray-700 px-2 py-2 rounded-[10px] bg-white shadow-[0_2px_8px_rgba(0,0,0,0.12)] mb-6 whitespace-nowrap">
                                <span className="font-semibold text-gray-900">
                                    🏆 Best Value
                                </span>

                                <span className="text-gray-500">
                                    = lowest $/unit among most relevant products
                                </span>
                            </div>
                        ) : (
                            <div style={{ marginBottom: "10px" }} />
                        )}
                    </div>
                );
            })}
            <div className="sticky bottom-0 z-[200] bg-white">
                <div className="max-w-[1200px]px-4 py-3">
                    <FooterSummary
                        newProductList={newProductList}
                        amazon_savings_amount={data?.amazon_savings_amount}
                        handleAddToCart={handleAddToCart}
                        selectedStore={selectedStore}
                        savingsAmount={savingsAmount}
                        savingsPercent={savingsPercent}
                        handleBackToMessages={handleBackToMessages}
                        shopperooRender={shopperooRender}
                        amazon_savings_percent={data?.amazon_savings_percent}
                        storeDetails={storeDetails}
                    />
                </div>
            </div>

            <Snackbar
                style={{ top: "80px" }}
                anchorOrigin={{ vertical: "top", horizontal: "right" }}
                open={snackData.show}
                autoHideDuration={3000}
                onClose={() => setSnackData({ show: false })}
            >
                <Alert
                    onClose={() => setSnackData({ show: false })}
                    severity={snackData.type}
                >
                    {snackData.message}
                </Alert>
            </Snackbar>
        </div>
    );
}
